//
//
//
//
//
//
//

import HomeHeader from '@/modules/home/components/home-header.vue';
import HomeNews from '@/modules/home/components/home-news.vue';
import HomeAbout from '@/modules/home/components/home-about.vue';
// import { mapActions } from 'vuex';

export default {
  components: {
    [HomeHeader.name]: HomeHeader,
    [HomeNews.name]: HomeNews,
    [HomeAbout.name]: HomeAbout,
  },
  mounted() {
    // this.setScrollMenu(true)
  },
  methods: {
    // ...mapActions({
    //   setScrollMenu: 'layout/setScrollMenu'
    // })
  }
};
